export const isStardogStudioWeb =
  typeof window !== 'undefined' &&
  window.location.hostname === 'stardog.studio';
